import toFixedValue from 'app/common/lib/toFixedValue'

import { ByPaymentMethodSchool } from '../types'

import { extractDateAndNameFromColumnKey } from './create-column-keys'
import { Entity } from './types'

export type CommonCell = {
  columnKey: string
  value: string
  type?: 'isOnlyTitle' | 'isTotal'
}

export type CommonRow = {
  rowKey: string
  rowData: Record<string, CommonCell>
}

export const createData = ({
  schools,
  columnKeysMain,
}: {
  schools: Array<ByPaymentMethodSchool>
  columnKeysMain: Array<string>
}) => {
  return schools.reduce((acc, { school_id: schoolId, title, items }) => {
    return [
      ...acc,
      // заголовок школы
      {
        rowKey: `${schoolId}-${Entity.IsOnlyTitle}`,
        rowData: columnKeysMain.reduce(
          (acc, key) => {
            acc[key] = {
              columnKey: key,
              value: '',
              type: 'isOnlyTitle',
            }
            return acc
          },
          {
            [Entity.Title]: {
              columnKey: Entity.Title as const,
              value: title,
              type: 'isOnlyTitle',
            },
            [Entity.TotalCount]: {
              columnKey: Entity.TotalCount as const,
              value: '',
              type: 'isOnlyTitle',
            },
            [Entity.TotalSum]: {
              columnKey: Entity.TotalSum as const,
              value: '',
              type: 'isOnlyTitle',
            },
          } as Record<string, CommonCell>,
        ),
      },
      // способы расчета
      ...items.map(({ title: itemTitle, total: { count, sum }, data_by_date: dataByDate }) => {
        return {
          rowKey: `${schoolId}-${itemTitle}`,
          rowData: columnKeysMain.reduce(
            (acc, key) => {
              const [name, date] = extractDateAndNameFromColumnKey(key)
              const itemData = dataByDate[date]
              if (!itemData) {
                console.warn(`Не найдено поле ${date} в 'data_by_date' в данных отчета`)
                return acc
              }
              acc[key] = {
                columnKey: key,
                value:
                  name === Entity.DateCount ? String(itemData.count) : toFixedValue(itemData.sum),
              }
              return acc
            },
            {
              [Entity.Title]: {
                columnKey: Entity.Title as const,
                value: itemTitle,
              },
              [Entity.TotalCount]: {
                columnKey: Entity.TotalCount as const,
                value: count || count === 0 ? String(count) : '',
              },
              [Entity.TotalSum]: {
                columnKey: Entity.TotalSum as const,
                value: toFixedValue(sum),
              },
            } as Record<string, CommonCell>,
          ),
        }
      }),
    ]
  }, [] as Array<CommonRow>)
}
